/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ccsl_Export_Header_Shot_DescriptionInputs */

const en_ccsl_export_header_shot_description = /** @type {(inputs: Ccsl_Export_Header_Shot_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SHOT DESCRIPTION`)
};

const fr_ccsl_export_header_shot_description = /** @type {(inputs: Ccsl_Export_Header_Shot_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DESCRIPTION DU PLAN`)
};

const de_ccsl_export_header_shot_description = /** @type {(inputs: Ccsl_Export_Header_Shot_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schussbeschreibung`)
};

const it_ccsl_export_header_shot_description = /** @type {(inputs: Ccsl_Export_Header_Shot_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DESCRIZIONE DELLA SCATTO`)
};

const ru_ccsl_export_header_shot_description = /** @type {(inputs: Ccsl_Export_Header_Shot_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ОПИСАНИЕ СЪЕМКИ`)
};

const es_ccsl_export_header_shot_description = /** @type {(inputs: Ccsl_Export_Header_Shot_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DESCRIPCIÓN DE LA TOMA`)
};

const zh_cn2_ccsl_export_header_shot_description = /** @type {(inputs: Ccsl_Export_Header_Shot_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`镜头描述`)
};

const ja_ccsl_export_header_shot_description = /** @type {(inputs: Ccsl_Export_Header_Shot_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ショットの説明`)
};

const hi_ccsl_export_header_shot_description = /** @type {(inputs: Ccsl_Export_Header_Shot_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`शॉट का विवरण`)
};

const pt_pt2_ccsl_export_header_shot_description = /** @type {(inputs: Ccsl_Export_Header_Shot_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DESCRIÇÃO DA TOMADA`)
};

/**
* | output |
* | --- |
* | "SHOT DESCRIPTION" |
*
* @param {Ccsl_Export_Header_Shot_DescriptionInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ccsl_export_header_shot_description = /** @type {((inputs?: Ccsl_Export_Header_Shot_DescriptionInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ccsl_Export_Header_Shot_DescriptionInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_ccsl_export_header_shot_description(inputs)
	if (locale === "de") return de_ccsl_export_header_shot_description(inputs)
	if (locale === "it") return it_ccsl_export_header_shot_description(inputs)
	if (locale === "ru") return ru_ccsl_export_header_shot_description(inputs)
	if (locale === "es") return es_ccsl_export_header_shot_description(inputs)
	if (locale === "zh-CN") return zh_cn2_ccsl_export_header_shot_description(inputs)
	if (locale === "ja") return ja_ccsl_export_header_shot_description(inputs)
	if (locale === "hi") return hi_ccsl_export_header_shot_description(inputs)
	if (locale === "pt-PT") return pt_pt2_ccsl_export_header_shot_description(inputs)
	return en_ccsl_export_header_shot_description(inputs)
});